import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import swal from "sweetalert";
import { disable2FA, twoFaSetup, twoFaVerify, userProfile } from '../../store/user/userThunk';
import { resetverificationStatus } from '../../store/user/userSlice';
import { LiaAngleLeftSolid } from "react-icons/lia";
import { FaQrcode, FaShieldAlt, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { toast } from 'react-toastify';
import Cookies from "js-cookie";

// CSS for the component
const styles = {
    modalHeader: {
        borderBottom: '1px solid #e9ecef',
        padding: '1.5rem 1.5rem',
        backgroundColor: '#f8f9fa'
    },
    modalTitle: {
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#212529'
    },
    backButton: {
        cursor: 'pointer',
        fontSize: '1.5rem',
        color: '#6c757d',
        marginRight: '1rem'
    },
    modalBody: {
        padding: '2rem 1.5rem'
    },
    progressContainer: {
        height: '0.5rem',
        backgroundColor: '#e9ecef',
        borderRadius: '0.25rem',
        margin: '0 0 2rem 0',
        overflow: 'hidden'
    },
    progressBar: {
        height: '100%',
        backgroundColor: '#007bff',
        borderRadius: '0.25rem',
        transition: 'width 0.3s ease'
    },
    stepTitle: {
        fontSize: '1.5rem',
        fontWeight: '600',
        marginBottom: '1rem',
        color: '#212529',
        textAlign: 'center'
    },
    stepDescription: {
        fontSize: '1rem',
        color: '#6c757d',
        marginBottom: '1.5rem',
        textAlign: 'center'
    },
    methodOption: {
        border: '1px solid #dee2e6',
        borderRadius: '0.5rem',
        padding: '1.25rem',
        margin: '0.75rem 0',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    methodOptionActive: {
        border: '2px solid #007bff',
        backgroundColor: 'rgba(0, 123, 255, 0.05)'
    },
    methodIcon: {
        fontSize: '1.5rem',
        marginRight: '1rem',
        color: '#6c757d'
    },
    methodIconActive: {
        color: '#007bff'
    },
    methodLabel: {
        fontWeight: '500',
        marginBottom: '0.25rem'
    },
    methodDescription: {
        fontSize: '0.875rem',
        color: '#6c757d'
    },
    setupSteps: {
        textAlign: 'left',
        margin: '1.5rem 0'
    },
    qrSection: {
        display: 'flex',
        justifyContent: 'center',
        padding: '1.5rem',
        background: '#f8f9fa',
        borderRadius: '0.5rem',
        margin: '1.5rem 0'
    },
    qrImage: {
        width: '100%',
        height: 'auto'
    },
    otpInput: {
        fontSize: '1.25rem',
        letterSpacing: '0.5rem',
        textAlign: 'center',
        padding: '0.75rem 1rem'
    },
    successSection: {
        textAlign: 'center',
        padding: '1rem 0'
    },
    successIcon: {
        fontSize: '4rem',
        color: '#28a745',
        margin: "auto"
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '1rem'
    },
    primaryButton: {
        width: '100%',
        padding: '0.75rem 1.5rem',
        fontWeight: '500',
        borderRadius: '0.375rem'
    },
    dangerButton: {
        backgroundColor: '#dc3545',
        borderColor: '#dc3545',
        width: '100%',
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        padding: '0.75rem 1.5rem',
        fontWeight: '500',
        borderRadius: '0.375rem'
    },
    secondaryButton: {
        padding: '0.75rem 1.5rem',
        fontWeight: '500',
        borderRadius: '0.375rem'
    }
};

const TwoFactorAuthModal = ({ setShow, show, setStep, step }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    const [showDisableConfirm, setShowDisableConfirm] = useState(false);

    const { twoFa, verificationStatus, Verifyerror, profile, disableStatus } = useSelector((state) => state.userservice);
    const dispatch = useDispatch();






    const handleClose = () => setShow(false);

    const handleNext = async () => {
        if (step === 1) {
            setStep(2);
        } else if (step === 2) {
            setStep(3);
        }
    };

    const handleBack = () => setStep(step > 1 ? step - 1 : 1);

    const handleOtpSubmit = async () => {
        if (!error) {
            await dispatch(twoFaVerify(otp)).unwrap().then((result) => {
                if (result) {
                    console.log(result, "-----2fa sucsess")
                    Cookies.set('twofatoken', result?.accessToken);
                    setStep(3);
                    dispatch(userProfile())


                }
            }).catch((err) => {
                toast.error(err?.message)
                console.log(err, "errerrerrerr")
            });
        }

    };

    const handleOtpChange = (e) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) {
            setError('OTP must contain only numbers.');
        } else if (value.length > 6) {
            setError('OTP cannot exceed 6 digits.');
        } else {
            setError(null);
            setOtp(value);
        }
    };

    const disable2FAlogin = () => {
        setShowDisableConfirm(true)
    };

    let confirmDisable2FA = () => {
        dispatch(disable2FA()).unwrap().then((result) => {
            if (result) {
                dispatch(userProfile())
                setShowDisableConfirm(false)
                setShow(false)
                    Cookies.remove('twofatoken')
            }
        });

    }

    return (
        <>



            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton style={styles.modalHeader}>
                    <Modal.Title className="w-100 d-flex align-items-center">
                        {step > 1 && (
                            <div style={styles.backButton} onClick={handleBack}>
                                <LiaAngleLeftSolid />
                            </div>
                        )}
                        <span style={styles.modalTitle}>Two-Factor Authentication</span>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={styles.modalBody}>
                    {step === 1 && (
                        <div>
                            <div style={styles.setupSteps}>

                                <h5>Set Up with an Authentication App</h5>
                                <ol className="text-left setup-steps">
                                    <li>Download an authentication app like Duo Mobile or Google Authenticator.</li>
                                    <li>
                                        Scan the QR code below or enter the key manually in your app.
                                        <div className="d-flex justify-content-center my-3">
                                            <div className="qr-section p-3 border rounded">
                                                <img src={twoFa?.qrCode} alt="QR Code" />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        After scanning, your app will generate a 6-digit code. Enter the code in the next step.
                                    </li>
                                </ol>



                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div>
                            <h4 style={styles.stepTitle}>Verify Your Identity</h4>
                            <p style={styles.stepDescription}>
                                Enter the 6-digit code from your authentication app
                            </p>

                            <Form.Group className="mb-4">
                                <Form.Control
                                    type="text"
                                    placeholder="000000"
                                    value={otp}
                                    onChange={handleOtpChange}
                                    maxLength={6}
                                    style={styles.otpInput}
                                />
                            </Form.Group>

                            {error && (
                                <Alert variant="danger" className="mb-4">
                                    {error}
                                </Alert>
                            )}
                        </div>
                    )}

                    {step === 3 && (
                        <div style={styles.successSection}>
                            <FaCheckCircle style={styles.successIcon} />
                            <h4 style={styles.stepTitle}>Two-Factor Authentication Enabled</h4>
                            <p style={styles.stepDescription}>
                                Your account is now protected with an additional layer of security.
                                You'll need to provide a verification code when signing in from new devices.
                            </p>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    {step < 3 ? (
                        <Button
                            variant="primary"
                            style={styles.primaryButton}
                            onClick={step === 1 ? handleNext : handleOtpSubmit}
                        >
                            {step === 3 ? "Verify Code" : "Continue"}
                        </Button>
                    ) : (
                        <Button
                            variant="danger"
                            style={styles.dangerButton}
                            onClick={disable2FAlogin}
                        >
                            <FaTimesCircle className="me-2" />
                            Disable Two-Factor Authentication
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>    <Modal show={showDisableConfirm} onHide={() => setShowDisableConfirm(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Disable Two-Factor Authentication</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to disable two-factor authentication? This will make your account less secure.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDisableConfirm(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmDisable2FA}>
                        Disable
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );
};

export default TwoFactorAuthModal;